import { render, staticRenderFns } from "./ruleConfig.vue?vue&type=template&id=04b41cd0&scoped=true&"
import script from "./ruleConfig.vue?vue&type=script&lang=js&"
export * from "./ruleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ruleConfig.vue?vue&type=style&index=0&id=04b41cd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b41cd0",
  null
  
)

export default component.exports